import axios from "axios";
// import {store} from "../../states/store";
const JWTInterceptor = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 6 * 60 * 1000, //6mins
});

const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts: any = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};
const requestHandler = (request: any) => {
  //console.log("document.cookie", document.cookie);
  request.meta = request.meta || {};
  request.meta.requestStartedAt = new Date().getTime();  
  let token = getCookie("accessToken") || "";
  let userID = getCookie("userId") || "";
  if (token && token !== "undefined") {
    //const parsedToken = JSON.parse(token);
    userID = userID || 0;
    //userID = "19";
    token = token || "";
  }
  request.headers.Authorization = `Bearer ${token}`;
  request.headers["Ocp-Apim-Subscription-Key"] = process.env.REACT_APP_API_KEY;
  request.headers["Source"] = "Web";
  request.headers["languagecode"] = (localStorage.getItem("languageCode") && localStorage.getItem("languageCode") !== "undefined" && localStorage.getItem("languageCode") !== "null") ? localStorage.getItem("languageCode") : "en";
  request.headers["UserId"] = userID;
  request.headers["Access-Control-Allow-Origin"] = "*";
  request.headers["Access-Control-Allow-Methods"] = "GET";
  if (!request.url.includes("getuserCountryList")) {
    request.headers["countryid"] = localStorage.getItem("countryId") || 0;
  }
  // if (request.url.includes("Profile")) {
  //   try {
  //     request.headers["countryid"] =
  //       store.getState().LoginReducer.selectedCounty.countryId;
  //   } catch (e) {
  //     request.headers["countryid"] = 0;
  //   }
  // }
  if (request.url.includes(process.env.REACT_APP_MULTIPART_UPLOAD)) {
    request.headers["Content-Type"] = "multipart/form-data";
  }

  if (request.url.includes("getoktarefreshtoken")) {
    request.headers["UserId"] = userID;
  }

  //}
  return request;
};

const responseHandler = (response: any) => {
  if (response.status === 401) {
    window.location.href = "/login";
  }
  return response;
};
function delete_cookie(name: string) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

const errorHandler = (error: any) => {

  if (error.response?.status === 401) {
    sessionStorage.clear();
    localStorage.clear();
    delete_cookie("codeVerifier");
    delete_cookie("refreshToken");
    delete_cookie("accessToken");
    delete_cookie("userId");
    delete_cookie("expiry");
    delete_cookie("tokenType");
    delete_cookie("token");
    window.location.href = "/admin/login";
  }
  return Promise.reject(error);
};

JWTInterceptor.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);
JWTInterceptor.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);
export default JWTInterceptor;
